import { addOrUpdateRestrictedTrades } from './helpers'
import { RestrictedTradesAction } from './actions'
import { RestrictedTrades } from './types'

export interface State {
  restrictedTrades?: RestrictedTrades[]
  pending: boolean
  error: boolean
}

export const initialState: State = {
  restrictedTrades: undefined,
  pending: true,
  error: false
}

export default (
  state = initialState,
  action: RestrictedTradesAction
): State => {
  switch (action.type) {
    case 'restrictedtrades.fetch':
      return {
        ...state,
        pending: true,
        restrictedTrades: undefined,
        error: false
      }
    case 'restrictedtrades.fetchFail':
      return {
        ...state,
        pending: false,
        error: true
      }
    case 'restrictedtrades.addRestrictedTrades':
      let items: RestrictedTrades[] = []

      if ('payload' in action) {
        items = action.payload ?? []
      }

      if (!state.restrictedTrades) {
        return {
          ...state,
          restrictedTrades: items
        }
      }

      return {
        ...state,
        restrictedTrades: addOrUpdateRestrictedTrades(
          state.restrictedTrades,
          items
        )
      }
    default:
      return state
  }
}
